// playSound.js
// Resilient playback: create a fresh audio per call, catch play rejections, resolve on error/end.

const playSound = (url, secs = null) => {
  if (!url) return Promise.resolve();

  return new Promise((resolve) => {
    const audio = new Audio(url);
    audio.crossOrigin = 'anonymous';
    audio.volume = 1;

    const cleanup = () => {
      audio.onended = null;
      audio.onerror = null;
      audio.oncanplaythrough = null;
    };

    const start = () => {
      const playPromise = audio.play();
      if (playPromise && typeof playPromise.catch === 'function') {
        playPromise.catch(() => {
          cleanup();
          resolve();
        });
      }
      if (secs !== null) {
        setTimeout(() => {
          audio.pause();
          audio.currentTime = 0;
          cleanup();
          resolve();
        }, secs * 1000);
      }
    };

    audio.onended = () => {
      cleanup();
      resolve();
    };
    audio.onerror = () => {
      cleanup();
      resolve();
    };

    if (audio.readyState >= 2) {
      start();
    } else {
      audio.oncanplaythrough = start;
    }
  });
};

export default playSound;
